import Collection   from 'ol/Collection'
import Fill         from 'ol/style/Fill'
import Stroke       from 'ol/style/Stroke'
import Style        from 'ol/style/Style'
import VectorLayer  from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON      from 'ol/format/GeoJSON'

import { ncExtent } from '../configuration/constants';

class Geoms {
  constructor(layerName, projection='EPSG:2264') {
    this.layerName = layerName;

    this.layer = new VectorLayer({
      layerName: layerName,
      extent: ncExtent,
      source: new VectorSource({
        features: new Collection(),
        projection: 'EPSG:2264'
      }),
      style: new Style({
        fill: new Fill({
            color: 'rgba(255, 0, 0, 0.1)'
        }),
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.25)',
            width: 3
        })
      })
    });
    this.layer.printLayer = true;
  }

  add(result) {
    const wkt = new GeoJSON();
    let feature = wkt.readFeature(result.geometry);
    feature.setId(result.id);
    this.layer.getSource().addFeature(feature);
    return feature;
  }

  clear() {
    this.layer.getSource().clear();
  }

  getExtent() {
    return this.layer.getSource().getExtent();
  }

  numFeatures() {
    return this.layer.getSource().getFeatures().length;
  }

  remove(feature) {
    this.layer.getSource().removeFeature(feature);
  }

  removeById(id) {
    const source = this.layer.getSource();
    const feature = source.getFeatureById(id);
    source.removeFeature(feature);
  }
}

export default Geoms;
